export default __webpack_public_path__ + "static/media/masai_refresh3.2c2271f6.png";